import {updateManualControlStartVolume} from '@/actions/manualControlActions';
import {MANUAL_CONTROL_ENUM} from '@/constants/enums';

import {PostStartManualUpdate} from './fetchManualControl';

// eslint-disable-next-line import/prefer-default-export
export function startManualControl() {
  return (dispatch, getState) => {
    const {manualControlStore, setupStore} = {...getState()};
    const {SelectedDefaultTime, RequestPendingManualControl, VolumeInMl, ManualControlState} = manualControlStore;
    const {currentVolume} = setupStore;

    if (!RequestPendingManualControl) {
      dispatch(updateManualControlStartVolume(currentVolume));

      const param = {
        TotRunTime:
          ManualControlState === MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL ? SelectedDefaultTime : VolumeInMl,
      };
      dispatch(PostStartManualUpdate(param));
    }
  };
}
